import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Tooltip, Link, ListItemText } from '@mui/material';
import RoleBasedGuard from 'src/auth/RoleBasedGuard';
import Iconify from 'src/components/iconify';
import { StyledItem, StyledIcon, StyledDotIcon } from './styles';
import { NavItemProps } from '../types';
import RenderItem from '../RenderItem';

// ----------------------------------------------------------------------

export default function StudioNavItem({
  item,
  depth,
  open,
  active,
  ...other
}: NavItemProps) {

  const { title, path, icon, info, children, disabled, caption, roles, selectionArea } = item;

  const subItem = depth !== 1;

  const renderContent = (
    <StyledItem depth={depth} active={active} disabled={disabled} caption={!!caption} {...other}>
      {icon && <StyledIcon>{icon}</StyledIcon>}

      {subItem && (
        <StyledIcon>
          <StyledDotIcon active={active && subItem} />
        </StyledIcon>
      )}

      <ListItemText
        primary={`${(title)}`}
        secondary={
          caption && (
            <Tooltip title={`${(caption)}`} placement="top-start">
              <span>{`${(caption)}`}</span>
            </Tooltip>
          )
        }
        primaryTypographyProps={{
          noWrap: true,
          component: 'span',
          variant: active ? 'subtitle2' : 'body2',
        }}
        secondaryTypographyProps={{
          noWrap: true,
          variant: 'caption',
        }}
      />

      {info && (
        <Box component="span" sx={{ lineHeight: 0 }}>
          {info}
        </Box>
      )}

      {!!children && (
        <Iconify
          width={16}
          icon={open ? 'eva:arrow-ios-downward-fill' : 'eva:arrow-ios-forward-fill'}
          sx={{ ml: 1, flexShrink: 0 }}
        />
      )}
    </StyledItem>
  );

  const renderItem = () => {
    // Has child
    if (children) {
      return renderContent;
    }

    // Default
    return (
      <Box >
        {renderContent}
      </Box>
    );
  };

  return <RoleBasedGuard roles={roles}> <RenderItem hasChildren={!!children} selectionArea={selectionArea} renderContent={renderContent} /> </RoleBasedGuard>;
}
